// mypreset.ts
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/material';

/**
 * Custom preset based on Aura with a darker base color (#1e1530)
 */
const MyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#f3f2f5',
      100: '#e2e0eb',
      200: '#cfc9dc',
      300: '#bcb1cd',
      400: '#483b69',
      500: '#332a49',
      600: '#1a1229',
      700: '#150f21',
      800: '#110b19',
      900: '#0c0710',
      950: '#060308',
    },
    secondary: {
      50: '#f5f4f9',
      100: '#e4e1f1',
      200: '#d2cdee',
      300: '#c1b8e8',
      400: '#aa96d9',
      500: '#7e5eb5',
      600: '#6c4e99',
      700: '#59407d',
      800: '#453161',
      900: '#302345',
      950: '#1a1327',
    },
    font: {
      text: '#ffffff', // default text color
      onPrimary: '#ffffff', // text on primary buttons
      onSecondary: '#ffffff', // text on secondary buttons
      muted: '#d1d1d6', // muted / placeholder text
      heading: '#f5f5f7', // headings
      link: '#85a1ff', // links
      success: '#16a34a',
      info: '#0284c7',
      warning: '#f59e0b',
      danger: '#dc2626',
    },
  },
});

export default MyPreset;
